<template>
    <div class="live-host-count info-box">
        <h3>直播数据</h3>

        <ul class="count-list">
            <li class="count-item">
                <img class="count-icon" src="~@/assets/images/live/icon-audience.png" alt="">
                <div class="count-content">
                    <p class="title">观看直播人数（人）</p>
                    <p class="number">{{count.total_watch_number || 0}}</p>
                </div>
            </li>
            <li class="count-item">
                <img class="count-icon" src="~@/assets/images/live/icon-view.png" alt="">
                <div class="count-content">
                    <p class="title">累计观看次数（次）</p>
                    <p class="number">{{count.total_watch_times || 0}}</p>
                </div>
            </li>
            <li class="count-item">
                <img class="count-icon" src="~@/assets/images/live/icon-concurrency.png" alt="">
                <div class="count-content">
                    <p class="title">累计观看时长（分钟）</p>
                    <p class="number">{{count.total_watch_duration || 0}}</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
// todo: 对数据
export default {
    props: ['id'],
    data() {
        return {
            count: {}
        }
    },
    mounted() {
        this.getCountList()
    },
    methods: {
        async getCountList() {
            let res = await this.$api.getLiveRoomReport(this.id)
            this.count = res.package
        }
    },
}
</script>

<style lang="scss">
.live-host-count {
    .count-list {
        display: flex;
        padding-left: 20px;
    }

    .count-item {
        display: flex;
        align-items: center;
        width: 20%;

        .count-icon {
            width: 64px;
            height: 64px;
        }

        .count-content {
            margin-left: 20px;
            .title {
                font-size: 14px;
                color: #a9a9a9;
            }

            .number {
                margin-top: 10px;
                font-size: 18px;
                color: #444444;
            }
        }
    }
}
</style>
